import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { personsGetAllQuery } from '../api/index.js'
import { DashboardHeader } from '../common/dashboardheader/dashboardheader.jsx'
import { DashboardCards } from './dashboardcards'

export default function DashboardView() {
	const personsQuery = useQuery(personsGetAllQuery).data
	const dashboardCards = useMemo(() => <DashboardCards personalDashboardData={personsQuery?.data} />, [personsQuery]) // do not re-render dashboard on every tick

	return (
		<>
			<DashboardHeader />
			{dashboardCards}
		</>
	)
}
